<template>
  <div>
    <b-modal
      v-model="showUpdateTag"
      type="warn"
      title="Confirm Update"
      @ok="saveTag"
      @cancel="resetData"
      ok-title="Yes, Save"
    >
      <p>Changes made to the tag will be reflected in all media calls it is being used at. Are you sure you want to save the tag?</p>
    </b-modal>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(showConfirmModal)">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Tag*</label>
              <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
                <input type="text" v-model="tagData.tag" class="form-control" ref="focusThis" />
                <span class="validate-error text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>
                Active: 
                <switches v-model="tagData.is_active" theme="bootstrap" v-if="!tagData.deliverable_count || tagData.deliverable_count == 0" color="primary"></switches>
                <switches v-b-tooltip.hover v-model="tagData.is_active" theme="bootstrap" v-if="tagData.deliverable_count > 0" title="Tag is being used in the system and cannot be archived." disabled="disabled" color="primary"></switches>
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <button class="btn btn-primary" type="submit" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Switches from 'vue-switches';

export default {
  props: ["tagData"],
  data() {
    return {
      showUpdateTag: false,
    };
  },
  components: {
    Switches
  },
  mounted() {
    if(this.tagData.id == '') {
      this.tagData.is_active = 1;
    }
  },
  methods: {
    resetData() {
      let self = this;
      if(self.$router.currentRoute.name == 'globalSearch') {
        let currentPageNumber = localStorage.getItem('currentPageNumber');
        let currentGSTab = localStorage.getItem('currentGSTab');
        self.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
      }
    },
    showConfirmModal() {
      if(this.tagData.id == '' || (!this.tagData.deliverable_count || this.tagData.deliverable_count == 0)) {
        this.saveTag();
      } else {
        this.showUpdateTag = true;
      }
    },
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
    saveTag() {
      let that = this;
      this.showUpdateTag = false;
      this.$store.dispatch("updateTag", this.tagData).then(function() {
        if(that.$router.currentRoute.name == 'globalSearch') {
          let currentPageNumber = localStorage.getItem('currentPageNumber');
          let currentGSTab = localStorage.getItem('currentGSTab');
          that.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
          that.$store.dispatch('manageUndoActivation', 'Tag saved.');
        }
      });
      this.$bvModal.hide("editTagModal");
    },
  },
};
</script>

<style>
</style>